const DATA_LAYER = "shplnDataLayer";
const GTAG_ID = "G-430EPZZG3B";
const UNKNOWN_SHOPIFY: Window["Shopify"] = {
    shop: "unknown",
    theme: { role: "development", id: -1, name: "Theme" },
};

export class Telemetry {
    public sessionId?: string;
    private env: "dev" | "prod";
    private runtime: "browser" | "node";
    private shopHandle: string;

    constructor() {
        this.runtime = typeof window !== "undefined" ? "browser" : "node";
        this.env = this.getEnv();
        this.shopHandle = this.getShopHandle();

        if (this.runtime === "browser") {
            this.sessionId = this.getSessionId();
            const scriptTag = document.createElement("script");
            scriptTag.src = `https://www.googletagmanager.com/gtag/js?id=${GTAG_ID}&l=${DATA_LAYER}`;
            scriptTag.setAttribute("id", "shpln-gtag");

            document.querySelector("head")?.prepend(scriptTag);

            window[DATA_LAYER] = window[DATA_LAYER] ?? [];

            if (window.shplnGtag == null) {
                window.shplnGtag = function () {
                    window[DATA_LAYER].push(arguments);
                };
                window.shplnGtag("js", new Date());
                window.shplnGtag("config", GTAG_ID);
            }
        } else {
            console.error(
                "[shpln-quiz] Current environment is not browser. Tracking will be disabled.",
            );
        }
    }

    public logEvent(action: string, data: any = {}) {
        console.log(`[shpln-quiz][event] ${action}`, data, this.shopHandle);

        if (this.runtime !== "browser" || this.env !== "prod") {
            return;
        }

        data.timestamp = Date.now();
        data.shop = this.shopHandle;
        data.shpln_session_id = this.sessionId;

        window.shplnGtag("event", action, data);
    }

    private getSessionId() {
        let sessionId = sessionStorage.getItem("shpln_quiz_session_id");
        if (sessionId == null) {
            sessionId = crypto.randomUUID();
            sessionStorage.setItem("shpln_quiz_session_id", sessionId);
        }
        return sessionId;
    }

    private getEnv() {
        const shopify = this.getShopify();

        if (shopify.theme.role !== "main") {
            return "dev";
        }

        return "prod";
    }

    private getShopify() {
        if (typeof window === "undefined" || window.Shopify == null) {
            return UNKNOWN_SHOPIFY;
        }
        return window.Shopify;
    }

    private getShopHandle() {
        const shopify = this.getShopify();
        return shopify.shop.replace(/.myshopify.com/, "");
    }
}
